import { ISpaceCollection } from "../SpaceCollection";

export interface ICampus extends ISpaceCollection {
}

export const schema = "AutomationApps.Collections.SpaceCollections.Campus"